import React from 'react';
import { TranslationService } from '../../../core/services';
import styles from './InfoHtml.module.scss';
import styled, { css } from "styled-components";
import { DictionaryType } from "../../../core/types/DictionaryType";
import { useAppContext } from "../../../AppContext";

type PropsType = {
  debtorName: string;
};

const InfoHtml = (props: PropsType) => {
  const context = useAppContext();

  return (
    <div className="container" id="InfoHtmlContainer">
      <InfoHtmlWrapper styles={context.styles} className={styles.wrapper}>
        <h1>
          {TranslationService.translate('Welcome')}{' '}
          <strong>{props.debtorName}</strong>
        </h1>

        {TranslationService.translate('DebtorWelcome')}
      </InfoHtmlWrapper>
    </div>
  );
};

const InfoHtmlWrapper = styled.div<{ styles: DictionaryType<DictionaryType<string>> }>`
  ${(props) => {
  const styleSettingName = props.styles[`module:info`];
  let styles = "";

  if (styleSettingName && styleSettingName.textColor) {
    styles = `
            color: ${styleSettingName.textColor}; 
            a { color: ${styleSettingName.textColor}; }
            ${styles}
        `;
  }

  if (styleSettingName && styleSettingName.backgroundColor) {
    styles = `background-color: ${styleSettingName.backgroundColor} !important; } ${styles}`;
  }

  return css`& { ${styles} }`;
}}
`;

export default InfoHtml;
